import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbButtonModule, NbCardModule } from '@nebular/theme';
import { AmplifyAuthService } from 'src/app/core/services/amplify-auth.service';
import { ENVIRONMENT } from 'src/environments/environment';

@Component({
  selector: 'app-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.css'],
  imports: [NbCardModule, NbButtonModule]
})
export class SignoutComponent implements OnInit {
  public environment = ENVIRONMENT.name;

  constructor(
    private router: Router,
    private amplifyAuthService: AmplifyAuthService
  ) {}

  public ngOnInit(): void {
    this.amplifyAuthService.signOut({ global: true });
  }

  public login() {
    this.router.navigate(['/login']);
  }
}
